var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page-flex"},[_c('main',[_c('p',[_vm._v("Articles")]),_c('posts-list')],1),_c('aside',[_c('tags-list',{attrs:{"a-class":"home","path":_vm.path,"tags":_vm.tags}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }